import balintSessionsClient from "@/axiosClients/balintSessionsClient";
import {errorHttpMessage} from "@/utils/errorDecodeUtil"

export const create = async ({commit}, data) => {
  try {
    const {data: result} = await balintSessionsClient.post('/balint-sessions', data)
    const {message, error} = result.result
    return {message, error}
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex)
    return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
  }
}

export const getBalintSessionById = async ({commit}, psychology_consultation_id) => {
  try {
    const {data: result} = await balintSessionsClient.get(`/balint-sessions/${psychology_consultation_id}`)
    const {data, message, error} = result.result
    return {data, message, error}
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message.message,
      error_keys: error_http_message.error_keys,
      data: ex.response.data,
      error: true
    }
  }
}

export const update = async ({commit}, sessionData) => {
  try{
      const { data: result } = await balintSessionsClient.post(`/balint-sessions/update/${sessionData.psychology_consultation_id}`, sessionData.data)
      const { data, message, error } = result.result
      return {data,message, error}        
  } catch(ex) {                     
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message.message,
      error_keys: error_http_message.error_keys,
      data: ex.response.data,
      error: true
    }
  } 
}

/** POST {baseURL}/balint-sessions/duplicate → /api/v1/balint-sessions/duplicate */
export const duplicate = async ({ commit }, payload) => {
  try {
    const { data: result } = await balintSessionsClient.post('/balint-sessions/duplicate', payload)
    const { data, message, error } = result.result
    return { data, message, error }
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex)
    return {
      message: error_http_message.message,
      error_keys: error_http_message.error_keys,
      data: ex.response.data,
      error: true
    }
  }
}

export const deleteBalintSession = async ({commit}, session_id) => {
  try{
    const { data: result } = await balintSessionsClient.delete(`/balint-sessions/${session_id}`)
    const { data, message, error } = result.result
    return {data,message, error}        
  } catch(ex) {                     
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message.message,
      error_keys: error_http_message.error_keys,
      data: ex.response.data,
      error: true
    }
  } 
}